export const paths = {
    lambdaUrl: "https://www.aws-geek.com/data/lambda/all",
    fargateUrl: "https://www.aws-geek.com/data/fargate/all",
    appRunnnerUrl: "https://www.aws-geek.com/data/appRunner/all",
    ec2Url: "https://www.aws-geek.com/data/ec2"
}